<div class="external-page">
  <div class="external-container">
    <h1>Подтверждение личных данных</h1>
    <p class="subtitle">Укажите номер паспорта и дайте согласие на обработку персональных данных для продолжения работы с порталом.</p>

    <form [formGroup]="form">
      <mat-card class="form-card">
        <mat-card-header>
          <mat-card-title>Паспортные данные</mat-card-title>
        </mat-card-header>
        <mat-card-content>

          <div class="passport-group">
            <mat-form-field appearance="outline" class="passport-type">
              <mat-label>Серия</mat-label>
              <mat-select formControlName="passportType">
                @for (type of passportTypes; track type.value) {
                <mat-option [value]="type.value">{{ type.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="passport-number">
              <mat-label>Номер паспорта</mat-label>
              <input matInput formControlName="passportNumber" placeholder="1234567" maxlength="7"
                (input)="onPassportNumberInput($event)">
              @if (form.get('passportNumber')?.hasError('required') && form.get('passportNumber')?.touched) {
              <mat-error>Введите номер паспорта</mat-error>
              }
              @if (form.get('passportNumber')?.hasError('pattern') && form.get('passportNumber')?.touched) {
              <mat-error>Номер должен состоять из 7 цифр</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="consent-row">
            <mat-checkbox formControlName="consentPersonalData" color="primary">
              Я даю согласие на обработку персональных данных
            </mat-checkbox>
            @if (form.get('consentPersonalData')?.hasError('required') && (form.get('consentPersonalData')?.touched || submitted())) {
            <p class="consent-error">Необходимо поставить галочку для продолжения</p>
            }
          </div>

          @if (errorMessage()) {
          <div class="error-message">
            <mat-icon>error</mat-icon>
            <span>{{ errorMessage() }}</span>
          </div>
          }

        </mat-card-content>
      </mat-card>

      <div class="form-actions">
        <button mat-raised-button color="primary" (click)="submit()" [disabled]="loading()">
          @if (loading()) {
          <mat-spinner diameter="20"></mat-spinner>
          } @else {
          Продолжить
          }
        </button>
      </div>
    </form>
  </div>
</div>
